export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.finance': 'Finance Management',
  'menu.finance.app-accounts': 'App Accounts',
  'menu.finance.deposits': 'Deposits',
  'menu.finance.withdraws': 'Withdraws',
  'menu.finance.crypto-recharges': 'Crypto Recharges',
  'menu.finance.crypto-withdraws': 'Crypto Withdrawals',
  'menu.finance.payment-records': 'Payment Records',
  'menu.finance.app-platforms': 'Withdraw Platforms',
  'menu.users': 'User Management',
  'menu.users.list': 'User List',
  'menu.system-management': 'System Management',
  'menu.system-management.overview': 'System Overview',
  'menu.system-management.messages': 'System Messages',
  'menu.system-management.announcements': 'Announcements',
  'menu.system-management.agent-popups': 'Agent Popup Announcements',
  'menu.system-management.marquee': 'Marquee Management',
  'menu.system-management.maintenance': 'Maintenance',
  'menu.game-management': 'Game Management',
  'menu.game-management.robot-config': 'Robot Config',
  'menu.game-management.promotion-bots': 'Promotion Bots',
  'menu.game-management.shan-rooms': 'Shankoemee Rooms',
  'menu.game-management.boogyi-rooms': 'Boogyi Rooms',
  'menu.game-management.shankoemee-history': 'Shankoemee History',
  'menu.game-management.boogyi-history': 'Boogyi History',
  'menu.game-management.tinyskm-history': 'TinySKM History',
  'menu.game-management.jili-history': 'JILI History',
  'menu.游戏管理.pragmatic-history': 'PP History',
};
